
import Footer from "../footer/Footer";
import Gallery from "../gallery/Gallery";
import Navbar from "../navbar/Navbar";
import Offer from "../offer/Offer";
import Review from "../review/Review";
import Section from "../section/Section";
import "./Work.css";

export default function Work() {
  const steps = [
    {
      number: "01",
      title: "Free Inspection",
      desc: "Share photos on WhatsApp or book a convenient doorstep inspection.",
      icon: "fa-magnifying-glass",
    },
    {
      number: "02",
      title: "Quote & Fabric",
      desc: "Choose your preferred fabric and materials with a transparent estimate.",
      icon: "fa-file-invoice-dollar",
    },
    {
      number: "03",
      title: "Pickup / On-Site",
      desc: "We repair your sofa at home or safely take it to our workshop.",
      icon: "fa-screwdriver-wrench",
    },
    {
      number: "04",
      title: "Delivery & Warranty",
      desc: "Get premium finishing, timely delivery and reliable post-service support.",
      icon: "fa-circle-check",
    },
  ];

  return (
    <div className="work-page">
      <Navbar />

      {/* Main Hero */}
      <Section />

      {/* Process Section */}
      <section className="process-section" id="process">
        <div className="container">

          {/* Heading */}
          <div className="process-heading">
            <span className="process-subtitle">SIMPLE & TRANSPARENT</span>

            <h2>
              How Our <span>Service Works</span>
            </h2>

            <p>
              From inspection to final delivery, we make sofa repair simple,
              transparent and hassle-free.
            </p>

            <div className="process-line"></div>
          </div>

          {/* Process Cards */}
          <div className="process-grid">
            {steps.map((step, index) => (
              <div className="process-item" key={step.number}>

                <div className="process-card">

                  {/* Number */}
                  <div className="process-number">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="process-icon">
                    <i className={`fa-solid ${step.icon}`}></i>
                  </div>

                  <h3>{step.title}</h3>

                  <p>{step.desc}</p>

                </div>

                {/* Connector */}
                {index < steps.length - 1 && (
                  <div className="process-connector">
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                )}

              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="process-cta">
            <div>
              <span>Need sofa repair?</span>
              <strong> Get a free inspection today.</strong>
            </div>

            <div className="process-buttons">

              <a
                href="tel:+919318333680"
                className="process-call-btn"
              >
                <i className="fa-solid fa-phone"></i>
                Call Now
              </a>

              <a
                href="https://wa.me/919318333680?text=Hi%2C%20I%20need%20a%20sofa%20repair%20inspection."
                target="_blank"
                rel="noopener noreferrer"
                className="process-whatsapp-btn"
              >
                <i className="fa-brands fa-whatsapp"></i>
                WhatsApp
              </a>

            </div>
          </div>

        </div>
      </section>

      {/* Gallery */}
      <Gallery />

      {/* Reviews */}
      <Review />

      {/* Offer */}
      <Offer />

      {/* Footer */}
      <Footer />
    </div>
  );
}
